import React, { useState, useEffect } from "react";
import styles from "./TableCourts.module.scss";
import { IArena, ICourt, TableCourtsPropsType } from "./types";
import { CourtTableSkeleton } from "./CourtTableSkeleton";
import { SeatsCell } from "../SeatsCell";
import { sortArenas } from "@/utils/courtRent/arenaNames";
import arrowLeftIcon from "@assets/icons/arrowCalendarLeft.svg";
import arrowRightIcon from "@assets/icons/arrowCalendarRight.svg";

export const TableCourts = ({
  gruntsAvailable,
  tableWidth,
  tableRef,
  arenas,
  gruntArenas,
  isLoading,
  grunt_id,
  dispatch,
  date,
  onSeatSelect,
  tableWrapperRef
}: TableCourtsPropsType) => {
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const courtTitles = renderCourtTitles();
  const seats = renderSeats();

  useEffect(() => {
    if (!tableWrapperRef?.current || isLoading) return;

    const checkScrollButtons = () => {
      const container = tableWrapperRef.current;
      if (!container) return;

      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    };

    const container = tableWrapperRef.current;
    container.addEventListener('scroll', checkScrollButtons);
    checkScrollButtons();

    const resizeObserver = new ResizeObserver(checkScrollButtons);
    resizeObserver.observe(container);

    return () => {
      container.removeEventListener('scroll', checkScrollButtons);
      resizeObserver.disconnect();
    };
  }, [tableWrapperRef, isLoading, arenas, gruntArenas]);

  const scrollLeft = () => {
    if (!tableWrapperRef?.current) return;
    tableWrapperRef.current.scrollBy({
      left: -300,
      behavior: 'smooth'
    });
  };

  const scrollRight = () => {
    if (!tableWrapperRef?.current) return;
    tableWrapperRef.current.scrollBy({
      left: 300,
      behavior: 'smooth'
    });
  };

  function renderCourtTitles() {
    let arenasTemp = arenas

    if (gruntsAvailable) {
      arenasTemp = gruntArenas
    }

    const sortedArenas = sortArenas(arenasTemp);

    return sortedArenas.map((arena: IArena) => (
      <th key={arena.id} className={styles.court_titles} data-arena-title={arena.title}>
        <div className={styles.court_title_flex}>
          {arena.courts.map((court: ICourt) => (
            <div
              id={`${court.id}`}
              key={court.id}
              className={styles.court_title}
              style={{ backgroundColor: `${court.cell_color}` }}
            >
              {court.title.replace('Хард', '')}
            </div>
          ))}
        </div>
      </th>
    ));
  }

  function renderSeats() {
    let renderSeatTime = "";
    let layoutSeats = [];
    let arenasTemp = arenas
    let beginingTime = 7

    if (gruntsAvailable) {
      arenasTemp = gruntArenas;
      beginingTime = +arenasTemp[0]?.seats[0]?.time?.slice(0, 2);
    }

    const sortedArenas = sortArenas(arenasTemp);

    for (let i = beginingTime; i < 24; i++) {
      const hour = i > 9 ? `${i}` : `0${i}`;
      renderSeatTime = `${hour}:00`;

      layoutSeats.push(
        <SeatsCell
          key={i}
          gruntsAvailable={gruntsAvailable}
          grunt_id={grunt_id}
          dispatch={dispatch}
          date={date}
          arenasTemp={sortedArenas}
          renderSeatTime={renderSeatTime}
          onSeatSelect={onSeatSelect}
        />
      );
    }

    return layoutSeats;
  }

  return (
    <div className={styles.tableContainer}>
      {canScrollLeft && (
        <button
          className={styles.scrollButtonLeft}
          onClick={scrollLeft}
          aria-label="Прокрутить влево"
        >
          <img src={arrowLeftIcon} alt="влево" />
        </button>
      )}
      <div 
        ref={tableWrapperRef}
        className={ gruntsAvailable ? styles.table_wrapper_grunt : styles.table_wrapper}
      >
        {isLoading ? (
          <CourtTableSkeleton />
        ) : (
          <div
            className={styles.table_main}
            style={tableWidth ? { width: `${tableWidth}px` } : { width: "1000%" }}
          >
            <table ref={tableRef}>
              <thead>
                <tr>{courtTitles}</tr>
              </thead>
              <tbody>{seats}</tbody>
            </table>
          </div>
        )}
      </div>
      {canScrollRight && (
        <button
          className={styles.scrollButtonRight}
          onClick={scrollRight}
          aria-label="Прокрутить вправо"
        >
          <img src={arrowRightIcon} alt="вправо" />
        </button>
      )}
    </div>
  )
}